
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getInitials } from "@/utils/mentorUtils";

interface MentorAvatarProps {
  imageUrl: string | null;
  name: string;
  size?: "sm" | "md" | "lg";
  id?: string;
  className?: string;
}

export const MentorAvatar: React.FC<MentorAvatarProps> = ({ 
  imageUrl, 
  name, 
  size = "md",
  id,
  className = ""
}) => {
  // Define size classes
  const sizeClasses = {
    sm: "h-12 w-12",
    md: "h-20 w-20",
    lg: "h-24 w-24"
  };

  // Get initials from name for fallback
  const initials = getInitials(name);

  // Log para debug das imagens
  React.useEffect(() => {
    if (id && imageUrl) {
      console.log(`🖼️ [MentorAvatar] Mentor ${id} - Image URL:`, imageUrl);
    } else if (id && !imageUrl) {
      console.log(`⚠️ [MentorAvatar] Mentor ${id} - No image URL provided`);
    }
  }, [id, imageUrl]);

  return (
    <Avatar className={`${sizeClasses[size]} border-4 border-[#00B6F0] shadow-xl ${className}`}>
      <AvatarImage 
        src={imageUrl || undefined} 
        alt={name}
        className="object-cover"
        onLoad={() => {
          if (id) console.log(`✅ [MentorAvatar] Image loaded successfully for mentor ${id}`);
        }}
        onError={(e) => {
          if (id) {
            console.log(`❌ [MentorAvatar] Failed to load profile image for mentor ${id}, URL:`, imageUrl);
            console.log(`❌ [MentorAvatar] Error details:`, e);
          }
        }}
      />
      <AvatarFallback className="bg-[#223342] text-[#00B6F0] text-xl">
        {initials || "MT"}
      </AvatarFallback>
    </Avatar>
  );
};
